import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'unauthenticated',
  imports: [],
  template: `<p>unauthenticated works!</p>`,
  styleUrl: './unauthenticated.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthenticatedComponent { }
